import Vue from 'vue';
export default Vue.extend({
    props: {
        active: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
});
